module.exports = "/assets/data/ffa452c732f0af00a5e05cdba4d751e1-SG4.data.json";